import React from 'react';

import { useIntl } from 'ha/i18n';
import Track from 'ha/components/track/SmartTrack';
import Button, { ButtonProps } from 'ha/ui/next/Button';

import ButtonRefreshArrows from 'streamline-icons/button-refresh-arrows.svg';

interface Props {
  onClick: () => void;
}

export const MapResetButton: React.FC<Props & ButtonProps> = ({
  className,
  onClick,
}) => {
  const { T } = useIntl();

  return (
    <Track name="Reset map clicked" type="button">
      <Button
        className={className}
        variant="contained"
        onClick={onClick}
        startIcon={<ButtonRefreshArrows color="mint" />}
      >
        {T('Reset map')}
      </Button>
    </Track>
  );
};

export default MapResetButton;
